import {AfterViewInit, Directive, ElementRef, Input} from '@angular/core';

@Directive({
    selector: '[rtAutofocus]',
    standalone: true
})
export class RtAutofocusInputDirective implements AfterViewInit {
  @Input() autoFocusEnable = true;
  constructor(private host: ElementRef) {}

  ngAfterViewInit(): void {
    if(this.autoFocusEnable) {
      this.host.nativeElement.focus();
    }
  }
}
